<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ userList?.userListName }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'LISTS.USER_LIST.TITLE' | translate"
        [previousPageUrl]="'/action-lists/manage/user-list'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="onAddToCampaignPressed()">
        {{ 'LISTS.USER_LIST.ADD_TO_CAMPAIGN' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <va-filtered-mat-table
      [tableDataService]="userListsDetailsService"
      limitContentHeightForDesktop="false"
    ></va-filtered-mat-table>
  </glxy-page-wrapper>
</glxy-page>
